import React, { memo, useState } from 'react';
import { useLocation } from 'react-router-dom';

import {
  Breadcrumbs,
  Button,
  Container,
  CssBaseline,
  FormControl,
  InputAdornment,
  Link,
  OutlinedInput,
} from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { HomeRounded, Search as SearchIcon } from '@material-ui/icons';

import AdminMenuList from '../shared/components/admin/AdminMenuList.component';

interface AdminLayoutProps {
  children: React.ReactNode;
}

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    topbar: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      padding: '0.5rem 0',
      height: 'calc(4svh + 1rem)',
      backgroundColor: '#222831',
    },
    link: {
      display: 'flex',
      color: '#9DB2BF',
    },
    icon: {
      fill: '#9DB2BF',
      marginRight: '0.5rem',
      width: 20,
      height: 20,
    },
    searchInput: {
      width: '15svw',
      '& .MuiOutlinedInput-root': {
        backgroundColor: '#9db2bf33',
        color: '#FFFFFF',
        paddingLeft: '10px',

        '& .MuiInputBase-input': {
          paddingTop: '0.5rem',
          paddingBottom: '0.5rem',
        },

        '& fieldset, &:hover fieldset, &.Mui-focused fieldset': {
          borderColor: '#9DB2BF',
        },
      },
    },
    menu: {
      width: '13svw',
      padding: '1svh 0.5rem',
      backgroundColor: '#222831',
    },
    content: {
      flexGrow: 1,
      height: '100svh',
      display: 'flex',
      flexDirection: 'column',
      paddingRight: '10px',
      alignItems: 'center',
      backgroundColor: '#222831',
    },
    container: {
      maxWidth: '87svw',
      width: '100%',
      height: '93svh',
      backgroundColor: '#EEEEEE',
      padding: '1rem',
      borderRadius: '5px',
      overflow: 'scroll',
      scrollbarColor: 'transparent transparent',
    },
    swapAdminButton: {
      backgroundColor: theme.palette.admin.primary.main,
      color: theme.palette.admin.primary.contrastText,
      '&:hover': {
        backgroundColor: theme.palette.admin.primary.dark,
      },
    },
  })
);

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const classes = useStyles();
  const [userSearch, setUserSearch] = useState('');

  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <div className={classes.root}>
      <CssBaseline />
      <section className={classes.menu}>
        <AdminMenuList currentPath={currentPath} />
      </section>
      <main className={classes.content}>
        <section className={classes.topbar}>
          <Breadcrumbs>
            <Link color="inherit" href="/admin-v2/statistics/overview" className={classes.link}>
              <HomeRounded className={classes.icon} />
              Dashboard
            </Link>
          </Breadcrumbs>
          <Button
            className={classes.swapAdminButton}
            size="small"
            variant="contained"
            color="primary"
            onClick={() => (window.location.href = '/admin')}
          >
            Admin v1
          </Button>
          {false && (
            <FormControl variant="outlined" size="small" className={classes.searchInput}>
              <OutlinedInput
                margin="dense"
                placeholder="Chercher un utilisateur"
                value={userSearch}
                onChange={(e) => setUserSearch(e.target.value)}
                startAdornment={
                  <InputAdornment position="start">
                    <SearchIcon style={{ fill: '#9DB2BF' }} />
                  </InputAdornment>
                }
              />
            </FormControl>
          )}
        </section>
        <Container maxWidth={false} className={classes.container}>
          {children}
        </Container>
      </main>
    </div>
  );
};

export default memo(AdminLayout);
